import makeRequest from '@jg/http-client';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { Auth } from '@jg/auth';
import { httpActions, apiActions } from '..';
import { REQUEST, ERROR_MESSAGES } from '../../consts';
import config from '../../config';
import { IAppState } from '../../types/state.d';
import { getTeamGuid } from '../../selectors/apiSelectors';
import { generateAuthHeaders, redirectByResponseStatus } from '../../utils';

const updateTeamName = (teamName: string) => async (
  dispatch: ThunkDispatch<IAppState, void, Action>,
  getState: () => IAppState,
  auth: Auth,
) => {
  const resourceName = REQUEST.UPDATE_TEAM_NAME;
  try {
    await auth.refreshAccessTokenIfExpired();
    dispatch(httpActions.httpRequestMade(resourceName));
    const teamGuid = getTeamGuid(getState());
    const response = await makeRequest(
      `${config.pagesAPI}v1/teams/${teamGuid}/details/name`,
      {
        method: 'PUT',
        body: JSON.stringify({
          teamGuid,
          name: teamName,
        }),
        extraHeaders: generateAuthHeaders(auth),
      },
    );
    if (response && !response.ok) {
      redirectByResponseStatus(response.status);
      throw new Error(ERROR_MESSAGES.UPDATE_TEAM_NAME);
    }
    dispatch(apiActions.saveTeamName(teamName));
    dispatch(httpActions.httpRequestSuccess(resourceName));
  } catch (error) {
    dispatch(httpActions.httpRequestError(resourceName, error));
    throw error;
  }
};

export default updateTeamName;
